'use strict';

angular.module('clientDashboardApp').directive('review-revisions', function () {

  return {
    restrict: 'E',
    replace: true,
    template: require('./reviewRevisions.html'),
    scope: {
      review: '=',
      index: '='
    },
    controller: () => {

    }

  };
});
